function pvInit() {
  const bar = document.querySelector(".pv-announcement-bar");
  if (!bar) return;

  const messages = bar.querySelectorAll(".pv-message");
  if (!messages.length) return;

  let index = 0;
  messages.forEach(m => m.classList.remove("is-active"));
  messages[0].classList.add("is-active");

  setInterval(() => {
    messages[index].classList.remove("is-active");
    index = (index + 1) % messages.length;
    messages[index].classList.add("is-active");
  }, 4000);
}

/* Run immediately */
pvInit();

/* Observe dynamic reload */
new MutationObserver(pvInit).observe(document.documentElement, {childList:true, subtree:true});
